import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { KeycloakService } from "@ogs/ngx-keycloak";
import { Permission } from "@shared/types/permission.types";


/**
 * Checks if given permissions match with the ones of the auth-token.
 * @param permissions
 * @returns
 */
export function permissionsGuard (permissions: Permission[]): CanActivateFn {
  return () => {
    const keycloakService: KeycloakService = inject(KeycloakService);
    const canActivate: boolean = permissions
      .every((permission: Readonly<Permission>): boolean => keycloakService
        .hasAccessTokenResourceAccess(permission.resource, permission.role));

    return canActivate;
  };
}
